// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2_x3l","col":"CardReaderDesc_col__2HV9o","label":"CardReaderDesc_label__3DybV"};